import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import CachedIcon from 'components/material-symbol/icons/Cached'
import {
  CALLOUT_FOREGROUND,
  PROMO_CALLOUT_BACKGROUND,
  PROMO_CALLOUT_BORDER,
  PROMO_CALLOUT_BORDER_RADIUS,
} from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 1.5),
    borderRadius: PROMO_CALLOUT_BORDER_RADIUS,
    border: `1px solid ${PROMO_CALLOUT_BORDER}`,
    backgroundColor: PROMO_CALLOUT_BACKGROUND,
    boxSizing: 'border-box',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: '1 1 auto',
    minWidth: 0,
  },
  label: {
    fontSize: '0.8125rem',
    lineHeight: 1.2,
    color: theme.palette.text.secondary,
    margin: 0,
    '&.MuiTypography-root': {
      margin: 0,
    },
  },
  labelHint: {
    color: theme.palette.text.secondary,
  },
  suggestion: {
    fontSize: '0.9375rem',
    fontWeight: 700,
    lineHeight: 1.2,
    color: CALLOUT_FOREGROUND,
    wordBreak: 'break-all',
    minWidth: 0,
    margin: 0,
    '&.MuiTypography-root': {
      margin: 0,
    },
  },
  actions: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      marginTop: theme.spacing(1),
    },
  },
  useButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 20,
    padding: theme.spacing(0.75, 1.5),
    minWidth: 'auto',
    height: 32,
    minHeight: 32,
    boxShadow: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  shuffleButton: {
    width: 32,
    height: 32,
    minHeight: 32,
    padding: 0,
    border: `1px solid ${PROMO_CALLOUT_BORDER}`,
    backgroundColor: theme.palette.common.white,
    color: CALLOUT_FOREGROUND,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
}))

const ProfileUrlSuggestion = ({
  onShuffle,
  onSubmit,
  templateHandlerResult,
  isUseDisabled = false,
  isShuffleDisabled = false,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Typography component="p" variant="inherit" className={classes.label}>
          Quick suggestion{' '}
          <span className={classes.labelHint}>(or enter your own above)</span>
        </Typography>
        <Typography
          component="p"
          variant="inherit"
          className={classes.suggestion}
        >
          {templateHandlerResult}
        </Typography>
      </Box>
      <Box className={classes.actions}>
        <Button
          type="button"
          variant="contained"
          color="primary"
          className={classes.useButton}
          onClick={onSubmit}
          disabled={isUseDisabled}
        >
          Use
        </Button>
        <IconButton
          type="button"
          className={classes.shuffleButton}
          onClick={onShuffle}
          aria-label="Show another suggestion"
          disabled={isShuffleDisabled}
        >
          <CachedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  )
}

ProfileUrlSuggestion.propTypes = {
  onShuffle: PropTypes.func,
  onSubmit: PropTypes.func,
  templateHandlerResult: PropTypes.string,
  isUseDisabled: PropTypes.bool,
  isShuffleDisabled: PropTypes.bool,
}

export default ProfileUrlSuggestion
